// utils/buildCutoffFilter.js
export function buildCutoffFilter() {
  const now        = new Date();              // local TZ (America/Los_Angeles)
  const year       = now.getFullYear();
  const monthIndex = now.getMonth();          // 0-based: Jan = 0 … Dec = 11

  // Rolling rule from the spec
  const dynamicCutoffYear = monthIndex < 6    // Jan-Jun?
    ? year - 4                                //  current year − 4
    : year - 3;                               //  current year − 3
  const dynamicIso = `${dynamicCutoffYear}-07-01`;

  // Hard floor: never go earlier than 01 Jul 2024
  const hardFloorIso = '2024-07-01';

  // Pick whichever date is *later* (stricter)
  const effectiveIso = dynamicIso < hardFloorIso ? hardFloorIso : dynamicIso;
  //   e.g. today (30 May 2025) → dynamicIso = "2021-07-01"
  //                                effectiveIso = "2024-07-01"

  return { injuryDate: { ge: effectiveIso } };
}
